import { render, staticRenderFns } from "./ChurnTable.vue?vue&type=template&id=453e17fc&scoped=true&"
import script from "./ChurnTable.vue?vue&type=script&lang=js&"
export * from "./ChurnTable.vue?vue&type=script&lang=js&"
import style0 from "./ChurnTable.vue?vue&type=style&index=0&id=453e17fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e17fc",
  null
  
)

export default component.exports